module.exports = __webpack_public_path__ + "static/media/astronomy2.a7007ab3.jpg";